module.exports = __webpack_public_path__ + "img/news_content.aa270461.jpg";